export default __webpack_public_path__ + "static/media/TV.727d27a0.svg";